import React, { useEffect } from "react";
import $ from "jquery";
import { Carousel } from 'primereact/carousel';


function Client() {


  const clients = [
    { src: "/assets/img/live_user/live_user1.webp", alt: "user1" },
    { src: "/assets/img/live_user/live_user2.webp", alt: "user2" },
    { src: "/assets/img/live_user/live_user3.webp", alt: "user1" },
    { src: "/assets/img/live_user/live_user4.webp", alt: "user2" },
    { src: "/assets/img/live_user/live_user5.webp", alt: "user1" },
    { src: "/assets/img/live_user/live_user6.webp", alt: "user2" },
    { src: "/assets/img/live_user/live_user7.webp", alt: "user1" },
    { src: "/assets/img/live_user/live_user8.webp", alt: "user2" },
    { src: "/assets/img/live_user/live_user9.webp", alt: "user1" },
    { src: "/assets/img/live_user/live_user10.webp", alt: "user2" },
    { src: "/assets/img/live_user/live_user11.webp", alt: "user1" },
    { src: "/assets/img/live_user/live_user12.webp", alt: "user2" },

  ];

  const responsiveOptions = [
    {
      breakpoint: "1024px",
      numVisible: 3,
      numScroll: 3
    },
    {
      breakpoint: "600px",
      numVisible: 1,
      numScroll: 1
    }
  ];

  const itemTemplate = (client) => {
    return (
      <div className="p‐m-2">
        <img src={client.src} alt={client.alt} className="img‐fluid" />
      </div>
    );
  };


  useEffect(() => {
    // Dynamically import inside useEffect so it runs in the browser


    // loadOwl();

    // optional cleanup
    return () => {
      if (window.$ && $(".owl-carousel").data("owl.carousel")) {
        $(".owl-carousel").trigger("destroy.owl.carousel");
      }
    };
  }, []);





  return (
    <>
      <section className="text-center lives_work pb-md-5 pb-4">
        <div className="container  ">
          <h3 className="text-center mb-4 mb-md-5">
            <img src="/assets/img/logo-white.svg" alt="about-logo" className='me-3 logo_white' />has change 10k+ lives around the world
          </h3>
          <Carousel
            value={clients}
            itemTemplate={itemTemplate}
            numVisible={3}
            numScroll={1}
            responsiveOptions={responsiveOptions}
            circular
            autoplayInterval={3000}
             className="no-dots-carousel"
          />


          {/* <div className="owl-carousel owl-theme">
            <div className="item">
              <img
                src="/assets/img/live_user/live_user1.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user2.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user3.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user4.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user5.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user6.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user7.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user8.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user9.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user10.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user11.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user12.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user13.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user14.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user15.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/img/live_user/live_user16.webp"
                alt="user"
                className="img-fluid"
              />
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Client;
